var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconModereCettePage = function SvgIconModereCettePage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-modere-cette-page",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "area",
    fill: "#ebebeb",
    opacity: 0.002,
    d: "M0 0h18v18H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(-589.282 -83.104)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "chat-bubbles"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    "data-name": "Path 101",
    d: "M601.948 100.1v-2.117a4.331 4.331 0 0 0-1-8.546h-3.333a4.333 4.333 0 0 0 0 8.667h1Z",
    fill: "#1eaae1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    d: "M595.948 92.771h1a4.334 4.334 0 1 0 0-8.667h-3.333a4.331 4.331 0 0 0-1 8.546v2.121Z",
    fill: "#bee6fa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "edit"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    d: "m598.99 93.8-.708 2.829 2.829-.708L605 92.039l-2.121-2.121Z",
    fill: "#ffce00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    d: "M606.767 88.149a1.494 1.494 0 0 0-2.117 0l-.708.707 2.122 2.122.7-.7a1.5 1.5 0 0 0 .003-2.129Z",
    fill: "#ffb49d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_19",
    "data-name": "Rectangle 19",
    transform: "rotate(45 194.71 773.446)",
    fill: "#505050",
    d: "M0 0h3v1.501H0z"
  })))));
};
export { SvgIconModereCettePage as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyBpZD0iaWNvbi1tb2RlcmUtY2V0dGUtcGFnZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCI+CiAgPHJlY3QgaWQ9ImFyZWEiIHdpZHRoPSIxOCIgaGVpZ2h0PSIxOCIgZmlsbD0iI2ViZWJlYiIgb3BhY2l0eT0iMC4wMDIiLz4KICA8ZyBpZD0iaWNvbiI+CiAgICA8ZyBpZD0iY2hhdC1idWJibGVzIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNTg5LjI4MiAtODMuMTA0KSI+CiAgICAgIDxwYXRoIGlkPSJQYXRoXzEwMSIgZGF0YS1uYW1lPSJQYXRoIDEwMSIgZD0iTTYwMS45NDgsMTAwLjFWOTcuOTgzYTQuMzMxLDQuMzMxLDAsMCwwLTEtOC41NDZoLTMuMzMzYTQuMzMzLDQuMzMzLDAsMCwwLDAsOC42NjdoMVoiIGZpbGw9IiMxZWFhZTEiLz4KICAgICAgPHBhdGggaWQ9IlBhdGhfMTAyIiBkYXRhLW5hbWU9IlBhdGggMTAyIiBkPSJNNTk1Ljk0OCw5Mi43NzFoMWE0LjMzNCw0LjMzNCwwLDEsMCwwLTguNjY3aC0zLjMzM2E0LjMzMSw0LjMzMSwwLDAsMC0xLDguNTQ2djIuMTIxWiIgZmlsbD0iI2JlZTZmYSIvPgogICAgPC9nPgogICAgPGcgaWQ9ImVkaXQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC01ODkuMjgyIC04My4xMDQpIj4KICAgICAgPHBhdGggaWQ9IlBhdGhfMTAzIiBkYXRhLW5hbWU9IlBhdGggMTAzIiBkPSJNNTk4Ljk5LDkzLjhsLS43MDgsMi44MjksMi44MjktLjcwOEw2MDUsOTIuMDM5bC0yLjEyMS0yLjEyMVoiIGZpbGw9IiNmZmNlMDAiLz4KICAgICAgPHBhdGggaWQ9IlBhdGhfMTA0IiBkYXRhLW5hbWU9IlBhdGggMTA0IiBkPSJNNjA2Ljc2Nyw4OC4xNDlhMS40OTQsMS40OTQsMCwwLDAtMi4xMTcsMGwtLjcwOC43MDcsMi4xMjIsMi4xMjIuNy0uN0ExLjUsMS41LDAsMCwwLDYwNi43NjcsODguMTQ5WiIgZmlsbD0iI2ZmYjQ5ZCIvPgogICAgICA8cmVjdCBpZD0iUmVjdGFuZ2xlXzE5IiBkYXRhLW5hbWU9IlJlY3RhbmdsZSAxOSIgd2lkdGg9IjMiIGhlaWdodD0iMS41MDEiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDYwMy45MzggODguODU3KSByb3RhdGUoNDUpIiBmaWxsPSIjNTA1MDUwIi8+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4K";